/*
 * @Description:
 * @Author: Rfan
 * @Date: 2021-10-18 16:37:43
 * @LastEditTime: 2021-10-20 12:02:29
 */

const state = {
  selectWorks:[]
};

const mutations = {
  CHANGE_VOTE: (state, {id, max=3}) => {
    console.log('store change', max);
    const selectIdx = state.selectWorks.indexOf(id);
      if (selectIdx >= 0) {
        state.selectWorks.splice(selectIdx, 1);
      } else {
        if (state.selectWorks.length < max) {
          state.selectWorks.push(id);
        }
      }
  },
};

export default {
  namespaced: true,
  state,
  mutations
};

